var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinDepositIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.19727,
    y: 14.457,
    width: 28.4033,
    height: 25.5216,
    rx: 2,
    fill: "#4C4577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6006 11.5195H33.6006C33.8492 11.5195 34.0877 11.6183 34.2635 11.7941C34.4393 11.9699 34.5381 12.2084 34.5381 12.457V29.457C34.5381 29.7057 34.4393 29.9441 34.2635 30.1199C34.0877 30.2958 33.8492 30.3945 33.6006 30.3945H11.6006C11.3519 30.3945 11.1135 30.2958 10.9377 30.1199C10.7619 29.9441 10.6631 29.7057 10.6631 29.457V12.457C10.6631 12.2084 10.7619 11.9699 10.9377 11.7941C11.1135 11.6183 11.3519 11.5195 11.6006 11.5195Z",
    fill: "#E3D7FB",
    stroke: "#CCB7F8",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6006 26.457C28.362 26.457 30.6006 24.2185 30.6006 21.457C30.6006 18.6956 28.362 16.457 25.6006 16.457C22.8392 16.457 20.6006 18.6956 20.6006 21.457C20.6006 24.2185 22.8392 26.457 25.6006 26.457Z",
    fill: "#B292F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_42_15582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6016 30.457V33.457",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6016 30.457V33.457",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6016 11.457H11.6016C11.0493 11.457 10.6016 11.9047 10.6016 12.457V29.457C10.6016 30.0093 11.0493 30.457 11.6016 30.457H33.6016C34.1538 30.457 34.6016 30.0093 34.6016 29.457V12.457C34.6016 11.9047 34.1538 11.457 33.6016 11.457Z",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5381 21.457C27.5381 22.5271 26.6706 23.3945 25.6006 23.3945C24.5305 23.3945 23.6631 22.5271 23.6631 21.457C23.6631 20.387 24.5305 19.5195 25.6006 19.5195C26.6706 19.5195 27.5381 20.387 27.5381 21.457Z",
    fill: "#F8F5FE",
    stroke: "#B292F4",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6006 21.457H34.6006",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74594 31.811L2.87297 33.684L1 31.811",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74594 26.1377L2.87297 28.0107L1 26.1377",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_42_15582",
    x: 2.60156,
    y: 10.457,
    width: 40,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_15582"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_42_15582"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_42_15582",
    result: "effect2_dropShadow_42_15582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_42_15582",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinDepositIcon);
export default __webpack_public_path__ + "static/media/minDeposit-icon.93a78f836df7d04992ce9d12e6497006.svg";
export { ForwardRef as ReactComponent };